import { render, staticRenderFns } from "./RfmList.vue?vue&type=template&id=83665d22&"
import script from "./RfmList.vue?vue&type=script&lang=js&"
export * from "./RfmList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports